(function () {
  "use strict";

  var COOKIE = "_mayekoo_attr";
  var MAX_AGE = 90 * 24 * 60 * 60;

  function cookieDomain() {
    var host = String(window.location.hostname || "");
    if (host === "mayekoo.com" || host.slice(-12) === ".mayekoo.com") return ".mayekoo.com";
    return "";
  }

  function readCookie(name) {
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(name + "=") === 0) {
        try {
          return decodeURIComponent(part.slice(name.length + 1));
        } catch (error) {
          return part.slice(name.length + 1);
        }
      }
    }
    return "";
  }

  function writeCookie(name, value) {
    var domain = cookieDomain();
    var cookie = name + "=" + encodeURIComponent(value)
      + "; Path=/; Max-Age=" + MAX_AGE + "; SameSite=Lax; Secure";
    if (domain) cookie += "; Domain=" + domain;
    document.cookie = cookie;
  }

  function b64urlEncode(text) {
    var bytes = new TextEncoder().encode(text);
    var binary = "";
    for (var i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  function b64urlDecode(token) {
    var padded = String(token || "").replace(/-/g, "+").replace(/_/g, "/");
    var pad = (4 - (padded.length % 4)) % 4;
    try {
      return atob(padded + "=".repeat(pad));
    } catch (error) {
      return "";
    }
  }

  function compact(touch) {
    if (!touch) return null;
    var next = {};
    var keys = ["utmSource", "utmMedium", "utmCampaign", "utmContent", "utmTerm", "fbclid", "fbc", "fbp", "landingPage", "referrer", "capturedAt"];
    for (var i = 0; i < keys.length; i += 1) {
      if (touch[keys[i]]) next[keys[i]] = String(touch[keys[i]]).slice(0, 240);
    }
    return Object.keys(next).length ? next : null;
  }

  function parseAttr(raw) {
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.v !== 1) return null;
      return { v: 1, first: compact(parsed.first), latest: compact(parsed.latest) };
    } catch (error) {
      return null;
    }
  }

  function readStored() {
    return parseAttr(b64urlDecode(readCookie(COOKIE))) || parseAttr(readCookie(COOKIE));
  }

  function writeStored(attr) {
    if (!attr) return;
    writeCookie(COOKIE, b64urlEncode(JSON.stringify(attr)));
  }

  function param(search, name) {
    var value = search.get(name);
    return value ? String(value).trim().slice(0, 200) : "";
  }

  function deriveFbc(fbclid, existing) {
    if (existing && existing.indexOf("fb.") === 0) {
      var existingClick = existing.split(".").slice(3).join(".");
      if (!fbclid || existingClick === fbclid) return existing;
    }
    if (!fbclid) return existing || "";
    return "fb.1." + Math.floor(Date.now() / 1000) + "." + fbclid;
  }

  function captureFromLocation() {
    var search = new URLSearchParams(window.location.search);
    var fbclid = param(search, "fbclid");
    var existingFbc = readCookie("_fbc");
    var fbp = readCookie("_fbp");
    var touch = compact({
      utmSource: param(search, "utm_source"),
      utmMedium: param(search, "utm_medium"),
      utmCampaign: param(search, "utm_campaign"),
      utmContent: param(search, "utm_content"),
      utmTerm: param(search, "utm_term"),
      fbclid: fbclid,
      fbc: deriveFbc(fbclid, existingFbc),
      fbp: fbp,
      landingPage: String(window.location.pathname + window.location.search).slice(0, 240),
      referrer: String(document.referrer || "").slice(0, 240),
      capturedAt: new Date().toISOString(),
    });
    var existing = readStored() || { v: 1 };
    if (touch && (touch.fbp || !existing.latest || !existing.latest.fbp)) {
      var latest = Object.assign({}, existing.latest || {}, touch.fbp ? { fbp: touch.fbp } : {});
      if (touch.utmSource || touch.utmMedium || touch.utmCampaign || touch.utmContent || touch.utmTerm || touch.fbclid) {
        latest = Object.assign({}, latest, touch);
      } else if (touch.fbc && !latest.fbc) {
        latest.fbc = touch.fbc;
      }
      var merged = {
        v: 1,
        first: existing.first || compact(latest),
        latest: compact(latest),
      };
      writeStored(merged);
      return merged;
    }
    if (touch && (touch.utmSource || touch.fbclid || touch.utmCampaign || touch.utmMedium)) {
      var next = {
        v: 1,
        first: existing.first || touch,
        latest: Object.assign({}, existing.latest || {}, touch),
      };
      writeStored(next);
      return next;
    }
    if (!existing.latest && touch) {
      var seeded = { v: 1, first: touch, latest: touch };
      writeStored(seeded);
      return seeded;
    }
    return existing.latest || existing.first ? existing : null;
  }

  function marketingAllowed() {
    try {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return true;
      if (typeof window.Shopify.customerPrivacy.marketingAllowed === "function") {
        return window.Shopify.customerPrivacy.marketingAllowed() !== false;
      }
    } catch (error) {
      return true;
    }
    return true;
  }

  function withFbq(callback) {
    if (!marketingAllowed()) return;
    var tries = 0;
    var run = function () {
      if (typeof window.fbq === "function") {
        callback(window.fbq);
        return;
      }
      tries += 1;
      if (tries > 40) return;
      setTimeout(run, 50);
    };
    run();
  }

  function contentFromRoot(root) {
    if (!root) return null;
    var causeId = root.getAttribute("data-evergreen-cause-id") || "";
    var productId = root.getAttribute("data-evergreen-product-id")
      || root.getAttribute("data-campaign-product-id")
      || "";
    var handle = root.getAttribute("data-evergreen-product-handle")
      || root.getAttribute("data-campaign-handle")
      || "";
    var name = root.getAttribute("data-evergreen-cause-name")
      || "";
    var title = "";
    var heading = root.querySelector(".mayekoo-fundraiser__title");
    if (heading) title = String(heading.textContent || "").trim();
    var ids = [];
    if (causeId) ids.push(causeId);
    if (productId) ids.push(String(productId).split("/").pop());
    if (handle) ids.push(handle);
    return {
      content_name: (name || title || handle || "Mayekoo donation").slice(0, 120),
      content_category: causeId ? "evergreen" : "fundraiser",
      content_ids: ids,
      content_type: "product",
      currency: "USD",
    };
  }

  function trackViewContent(root) {
    var payload = contentFromRoot(root);
    if (!payload) return;
    var key = "mayekoo_vc:" + window.location.pathname + ":" + (payload.content_ids[0] || "page");
    try {
      if (sessionStorage.getItem(key) === "1") return;
      sessionStorage.setItem(key, "1");
    } catch (error) {}
    withFbq(function (fbq) {
      fbq("track", "ViewContent", payload);
    });
  }

  function cartValue(cart) {
    var cents = Number(cart && cart.total_price);
    if (!Number.isFinite(cents) || cents < 0) return undefined;
    return Number((cents / 100).toFixed(2));
  }

  function trackInitiateCheckout(input) {
    var cart = input && input.cart ? input.cart : {};
    var meta = input && input.meta ? input.meta : {};
    var value = cartValue(cart);
    var payload = {
      currency: String((cart.currency || "USD")).toUpperCase(),
      num_items: Array.isArray(cart.items) ? cart.items.length : 1,
      content_type: "product",
      content_ids: [],
      content_name: meta.causeName || meta.handle || meta.contentName || "Mayekoo donation",
      content_category: meta.causeId ? "evergreen" : (meta.category || "donation"),
    };
    if (typeof value === "number") payload.value = value;
    if (meta.causeId) payload.content_ids.push(meta.causeId);
    if (meta.productId) payload.content_ids.push(String(meta.productId).split("/").pop());
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (item && item.variant_id) payload.content_ids.push(String(item.variant_id));
      });
    }
    withFbq(function (fbq) {
      fbq("track", "InitiateCheckout", payload);
    });
    trackBeginCheckout(cart, payload);
  }

  function trackBeginCheckout(cart, payload) {
    if (typeof window.gtag !== "function") return;
    try {
      var items = (cart.items || []).map(function (item) {
        return {
          item_id: item.variant_id,
          item_name: item.product_title || item.title,
          price: Number(item.final_price || 0) / 100,
          quantity: item.quantity || 1,
        };
      });
      window.gtag("event", "begin_checkout", {
        currency: payload.currency,
        value: payload.value,
        items: items,
      });
    } catch (error) {}
  }

  function attachAttrToCnote(cnote) {
    var attr = readStored();
    var token = attr ? b64urlEncode(JSON.stringify(attr)) : "";
    var base = String(cnote || "");
    if (!token) return base;
    if (base.indexOf("mayekoo:v1:") === 0) {
      try {
        var raw = b64urlDecode(base.slice("mayekoo:v1:".length));
        var payload = JSON.parse(raw);
        payload.at = attr;
        var bytes = new TextEncoder().encode(JSON.stringify(payload));
        var binary = "";
        for (var i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
        return "mayekoo:v1:" + btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
      } catch (error) {
        return base;
      }
    }
    if (base.indexOf("_mayekoo_attr=") >= 0) return base;
    return base + (base ? ";" : "") + "_mayekoo_attr=" + token;
  }

  function scanViewContent() {
    document.querySelectorAll("[data-mayekoo-evergreen],[data-mayekoo-fundraiser]").forEach(function (root) {
      trackViewContent(root);
    });
  }

  captureFromLocation();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanViewContent);
  } else {
    scanViewContent();
  }
  document.addEventListener("shopify:section:load", scanViewContent);

  window.__mayekooAds = {
    cookieName: COOKIE,
    captureFromLocation: captureFromLocation,
    readAttribution: readStored,
    attachAttrToCnote: attachAttrToCnote,
    trackViewContent: trackViewContent,
    trackInitiateCheckout: trackInitiateCheckout,
    trackBeginCheckout: trackBeginCheckout,
  };
})();
